import HomePage from "../pages/HomePage";
import LoginSignInPage from "../pages/LoginSignInPage/Login";
import ForgotPassword from "../pages/LoginSignInPage/ForgotPassword";
import SignUp from "../pages/LoginSignInPage/SiginUp";
import SelectVariantPage from "../pages/Seggregation/SelectVariantPage";
import Seggregation from "../pages/Seggregation";
import AddSubCategoryPage from "../pages/Seggregation/AddSubCategoryPage";
import OrderListPage from "../pages/Dashboard/OrderListPage";
import UploadImagesPage from "../pages/Dashboard/UploadImagesPage";
import UploadGuidelinePage from "../pages/Dashboard/UploadGuidelinePage";
import OrderSummaryPage from "../pages/Dashboard/OrderSummaryPage";
import SelectMarketplacePage from "../pages/Dashboard/SelectMarketplacePage";
import UpdateSetPage from "../pages/Guidelines/UpdateSetPage";
import SequencingPage from "../pages/Dashboard/SequencingPage";
import AddOnServicesPage from "../pages/Dashboard/AddOnServicesPage";
import SkuListPage from "../pages/Dashboard/SkuListPage";
import SeggregrationBatchListPage from "../pages/Seggregation/SeggregationBatchListPage";
import BatchLoadingPage from "../pages/Seggregation/BatchLoadingPage";
import SequenceVariantPage from "../pages/Seggregation/SequenceVariantPage";
import SelectAddOnPage from "../pages/Seggregation/SelectAddOnPage";
import ReviewSkuListPage from "../pages/Review/ReviewSkuListPage";
import ReviewDetailPage from "../pages/Review/ReviewDetailPage";
import ReviewBatchListPage from "../pages/Review/ReviewBatchListPage";
import CreateRequestPage from "../pages/CreateRequestPage";
import RequestInboxPage from "../pages/RequestInboxPage";
import PaymentSuccessPage from "../pages/Dashboard/PaymentSuccessPage";
import PaymentFailurePage from "../pages/Dashboard/PaymentFaiurePage";
import BillingDetailsPage from "../pages/Dashboard/BiilingDetailsPage";
import BatchQuoteDetailsPage from "../pages/Dashboard/BatchQuoteDetailsPage";
import ViewGuidelinesPage from "../pages/Guidelines/ViewGuidelinesPage";
import UsersListPage from "../pages/Users/UserListPage";
import AdminBatchListPage from "../pages/Admin/AdminBatchListPage";
import AdminSkuListPage from "../pages/Admin/AdminSkuListPage";
import AdaptationViewPage from "../pages/AdaptationViewPage";
import CreateSetPage from "../pages/Guidelines/CreateSetPage";
import DownloadPage from "../pages/Download/DownloadPage";
import RechargeWallet from "../components/RechargeWallet";
import BillingPage from "../pages/BillingPage";
import BSTSeggregationPage from "../pages/Seggregation/BST2Seggeregation";
import BST2DashboardPage from "../pages/BST2DashboardPage";

export const routesList = [
  {
    path: `/`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: HomePage,
  },
  {
    path: `/create-set`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: CreateSetPage,
  },
  {
    path: `/update-set/:guidelineId/:angleSetId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: UpdateSetPage,
  },
  {
    path: `/login`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: LoginSignInPage,
  },
  {
    path: `/signup`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SignUp,
  },
  {
    path: `/forgot-password`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: ForgotPassword,
  },
  {
    path: `/select-variant/:skuId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SelectVariantPage,
  },
  {
    path: `/seggregation`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: Seggregation,
  },
  {
    path: `/select-category/:skuId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: AddSubCategoryPage,
  },
  {
    path: `/order-list`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: OrderListPage,
  },
  {
    path: `/upload-images/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: UploadImagesPage,
  },
  {
    path: `/upload-guideline/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: UploadGuidelinePage,
  },
  {
    path: `/order-summary/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: OrderSummaryPage,
  },
  {
    path: `/select-marketplace/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SelectMarketplacePage,
  },
  {
    path: `/sequencing/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SequencingPage,
  },
  {
    path: `/add-on-services/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: AddOnServicesPage,
  },
  // {
  //   path: `/sku-list/:batchId`,
  //   title: "ImageEdit",
  //   exact: true,
  //   protected: true,
  //   component: SkuListPage,
  // },
  {
    path: `/sku-list/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SkuListPage,
  },
  {
    path: `/review-sku-list/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: ReviewSkuListPage,
  },
  {
    path: `/review-detail/:batchId/:skuId/:activeFileId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: ReviewDetailPage,
  },
  {
    path: `/review-batch-list`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: ReviewBatchListPage,
  },
  {
    path: `/seggregation-batch-list`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SeggregrationBatchListPage,
  },
  {
    path: `/admin/batches`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: AdminBatchListPage,
  },
  {
    path: `/admin/batches/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: AdminSkuListPage,
  },
  {
    path: `/seggregation-batch-loading`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: BatchLoadingPage,
  },
  {
    path: `/sequence-variant/:skuId/:guidelineId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SequenceVariantPage,
  },
  {
    path: `/select-add-on/:skuId/`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: SelectAddOnPage,
  },
  {
    path: `/create-request`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: CreateRequestPage,
  },
  {
    path: `/requests`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: RequestInboxPage,
  },
  {
    path: `/success`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: PaymentSuccessPage,
  },
  {
    path: `/failure`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: PaymentFailurePage,
  },
  {
    path: `/billing-details/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: BillingDetailsPage,
  },
  {
    path: `/batch-quote-list/:batchId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: BatchQuoteDetailsPage,
  },
  {
    path: `/view-guidelines`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: ViewGuidelinesPage,
  },
  {
    path: `/users-list`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: UsersListPage,
  },
  {
    path: `/adaptation-view`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: AdaptationViewPage,
  },
  {
    path: `/download`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: DownloadPage,
  },
  {
    path: `/recharge`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: RechargeWallet,
  },
  {
    path: `/billing`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: BillingPage,
  },
  {
    path: `/bst-seggregation/:skuId/:marketplaceId`,
    title: "ImageEdit",
    exact: true,
    protected: true,
    component: BSTSeggregationPage,
  },
  {
    path: `/bst2-dashboard`,
    title: "BST2 Dashboard",
    exact: true,
    protected: true,
    component: BST2DashboardPage,
  },
];
